module.exports = __webpack_public_path__ + "static/media/jardines01M.d7583e95.jpg";